/* Quick add: prepare the inert product HTML before Dawn mounts it.
 * Moving live variant-selects would register its change handler a second time.
 * Keep Dawn's fetch, variant updates and cart submission unchanged.
 *
 * Tamanho começa sem seleção, mesmo gate que a PDP real ganhou em
 * assets/ws-size-gate.js/snippets/ws-size-gate.liquid (07/09/2026) — botão
 * aria-disabled (não disabled, mantém no tab order) + texto "Select size" +
 * guard de clique próprio aqui (o produto ainda está desconectado do
 * documento neste ponto, então o listener registrado aqui sobrevive quando
 * o nó for inserido depois). O spinner-ao-trocar-de-tamanho e a reversão do
 * aria-disabled/texto no PUB_SUB_EVENTS.variantChange são cobertos por
 * assets/ws-size-gate.js — esse arquivo hoje trata qualquer product-info da
 * página, dentro ou fora de quick-add-modal, então não precisa de código
 * duplicado aqui.
 */
(function () {
  // Multiple collection sections can include this shared asset.
  if (window.wsQuickAddInitialized) return;
  window.wsQuickAddInitialized = true;

  const preparedModals = new WeakSet();

  function prepareProduct(product) {
    if (!product.matches('product-info')) return;
    const info = product.querySelector('.product__info-container');
    const picker = info?.querySelector('variant-selects');
    const buyButtons = info?.querySelector('product-form')?.parentElement;
    if (!picker || !buyButtons || info.querySelector('.ws-quick-add__summary')) return;

    const summary = product.ownerDocument.createElement('div');
    summary.className = 'ws-quick-add__summary';
    const details = product.ownerDocument.createElement('div');
    details.className = 'ws-quick-add__details';
    const media = product.querySelector('.product__media-wrapper');
    if (media) summary.append(media);
    for (const selector of ['.product__title', '[id^="price-"]', '.product__view-details']) {
      const node = info.querySelector(selector);
      if (node) details.append(node);
    }
    summary.append(details);
    const actions = product.ownerDocument.createElement('div');
    actions.className = 'ws-quick-add__actions';
    actions.append(picker, buyButtons);
    info.prepend(summary, actions);

    // Only size starts empty; preserve any other option used to resolve
    // variants. data-option-name, não <legend>/texto (mesmo motivo do fix
    // em ws-size-gate.liquid: só funciona com picker_type "button"; com
    // dropdown/swatch, o gate desligaria sozinho, sem erro).
    const sizeRadios = Array.from(picker.querySelectorAll('input[type="radio"][data-option-name]')).filter(
      (input) => input.dataset.optionName.trim().toLowerCase() === 'size'
    );
    // Só 1 valor (ex. "One Size") não tem nada pra escolher — gatear aqui
    // só forçaria um clique sem sentido, sem prevenir erro nenhum.
    if (sizeRadios.length < 2) return;

    sizeRadios.forEach((input) => {
      input.removeAttribute('checked');
      input.checked = false;
      input.required = true;
    });

    buyButtons.querySelector('[name="id"]').value = '';

    const submitButton = buyButtons.querySelector('[type="submit"]');
    if (!submitButton) return;

    const textEl = submitButton.querySelector('span');
    if (textEl) {
      submitButton.dataset.wsOriginalText = textEl.textContent;
      textEl.textContent = 'Select size';
    }
    submitButton.setAttribute('aria-disabled', 'true');

    // product ainda está desconectado aqui — o listener sobrevive à
    // inserção no documento, mesma referência de nó.
    product.addEventListener(
      'click',
      (event) => {
        if (submitButton.getAttribute('aria-disabled') !== 'true') return;
        if (event.target.closest('[type="submit"]') !== submitButton) return;
        event.preventDefault();
        event.stopPropagation();
      },
      true
    );
  }

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('modal-opener');
    const modal = opener && document.querySelector(opener.dataset.modal);
    if (!modal?.classList.contains('quick-add-modal--compact') || preparedModals.has(modal)) return;
    preparedModals.add(modal);

    const content = modal.querySelector('.quick-add-modal__content');
    content.classList.add('drawer__inner', 'motion-reduce');
    const heading = document.createElement('h2');
    heading.className = 'ws-quick-add__heading';
    heading.textContent = opener.querySelector('button > span')?.textContent.trim();
    content.prepend(heading);

    // Reuse the cart drawer close pattern and the SVG already rendered by Liquid.
    const close = modal.querySelector('.quick-add-modal__toggle');
    close.classList.add('drawer__close');
    const icon = close.querySelector('svg');
    const wrapper = document.createElement('span');
    wrapper.className = 'svg-wrapper';
    wrapper.append(icon);
    close.append(wrapper);

    const preprocess = modal.preprocessHTML.bind(modal);
    modal.preprocessHTML = (product) => {
      preprocess(product);
      prepareProduct(product);
    };
  }, true);
})();
